// common/useAccessibleId.js
import { useId } from 'react';

function toKebabCase(value) {
  if (!value) return '';

  return value
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2') // camelCase → kebab
    .replace(/[\s_]+/g, '-')               // spaces & underscores
    .replace(/[^a-zA-Z0-9-]/g, '')         // strip unsafe chars
    .toLowerCase();
}

export function useAccessibleId(fieldName, prefix = 'field') {
  const reactId = useId(); // stable, SSR-safe

  const base = fieldName
    ? toKebabCase(fieldName)
    : prefix;

  return `${base}-${reactId}`;
}